/* RESPONSIBLE TEAM: team-inbox-management */

enum Theme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export default Theme;
